/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_OverlapsInputs */

const en_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix Overlaps`)
};

const fr_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corriger les chevauchements`)
};

const de_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappungen beheben`)
};

const it_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correggi sovrapposizioni`)
};

const ru_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Устранить наложения`)
};

const es_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corregir superposiciones`)
};

const zh_cn2_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修复重叠`)
};

const ja_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複を修正`)
};

const hi_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरलैप को ठीक करें`)
};

const pt_pt2_fix_overlaps = /** @type {(inputs: Fix_OverlapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrigir sobreposições`)
};

/**
* | output |
* | --- |
* | "Fix Overlaps" |
*
* @param {Fix_OverlapsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const fix_overlaps = /** @type {((inputs?: Fix_OverlapsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_OverlapsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_fix_overlaps(inputs)
	if (locale === "de") return de_fix_overlaps(inputs)
	if (locale === "it") return it_fix_overlaps(inputs)
	if (locale === "ru") return ru_fix_overlaps(inputs)
	if (locale === "es") return es_fix_overlaps(inputs)
	if (locale === "zh-CN") return zh_cn2_fix_overlaps(inputs)
	if (locale === "ja") return ja_fix_overlaps(inputs)
	if (locale === "hi") return hi_fix_overlaps(inputs)
	if (locale === "pt-PT") return pt_pt2_fix_overlaps(inputs)
	return en_fix_overlaps(inputs)
});